import { render, staticRenderFns } from "./BottoniPezzo.vue?vue&type=template&id=ac329f16&"
import script from "./BottoniPezzo.vue?vue&type=script&lang=js&"
export * from "./BottoniPezzo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports